module.exports = __webpack_public_path__ + "img/yc3.8b35233e.png";